var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"flex-common"},_vm._l((_vm.crumbs),function(item,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":item.route}},[_vm._v(_vm._s(item.text))]),_c('i')],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }